import {DeliveryLocationStatus} from '@buncha/batchDetails/types';
import moment from 'moment';

export const getCurrentStepByDeliverStatus = (
  status?: DeliveryLocationStatus,
) => {
  const stepOrder = [
    ['notStarted', 'pending'], // OrderPlaceStep
    [
      'readyToPack',
      'orderPacked',
      'toBeAssigned',
      'driverAssigned',
      'handoverFailed',
      'awaitingHandover',
    ], // ShoppingStep
    ['onTheWay'], // DriverStep
    ['delivered', 'deliveryFailed'], // DeliveryStep
  ];
  if (!status) return -1;
  return stepOrder.findIndex(statuses => statuses.includes(status));
};

export function decryptFromBase64(str: string): string {
  // Browser-safe base64 -> string decoding. `atob` decodes to a binary string
  try {
    // atob can throw for invalid input; if it's not available (very unusual
    // in browser builds), return the original string to avoid runtime errors.
    if (typeof atob !== 'function') return str;
    const binary = atob(str);
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    // Use TextDecoder if available for proper UTF-8 decoding
    if (typeof TextDecoder !== 'undefined')
      return new TextDecoder('utf-8').decode(bytes);
    // Fallback: decode assuming each byte maps to a char code
    let result = '';
    for (const b of bytes) result += String.fromCharCode(b);
    return result;
  } catch (e) {
    // to log-in screen
    return '';
  }
}

export function encryptToBase64(str: string): string {
  try {
    // Browser: use TextEncoder -> binary string -> btoa for correct UTF-8 handling
    if (typeof TextEncoder !== 'undefined' && typeof btoa === 'function') {
      const bytes = new TextEncoder().encode(str);
      let binary = '';
      for (const b of bytes) binary += String.fromCharCode(b);
      return btoa(binary)
        .replace(new RegExp('=+$'), '')
        .replace(new RegExp('\\+', 'g'), '-')
        .replace(new RegExp('/', 'g'), '_');
    }
    // Node fallback
    if (typeof Buffer !== 'undefined')
      return Buffer.from(str)
        .toString('base64')
        .replace(new RegExp('=+$'), '')
        .replace(new RegExp('\\+', 'g'), '-')
        .replace(new RegExp('/', 'g'), '_');
  } catch (e) {
    // ignore and fallthrough to return original string
  }
  // If neither available, return input
  return str;
}

export function getDayLabel(inputDate: Date | string | number | undefined) {
  if (!inputDate) return '';

  const inputStart = moment(inputDate).startOf('day');
  const todayStart = moment().startOf('day');

  const diffInDays = inputStart.diff(todayStart, 'days');

  switch (diffInDays) {
    case -1:
      return 'Yesterday';
    case 0:
      return 'Today';
    case 1:
      return 'Tomorrow';
    default:
      return moment(inputDate).format('dddd');
  }
}

export function getFormattedSlotsDate(
  input: Date | string | number | undefined,
) {
  const inputDate = moment(input);
  const todayDate = moment();

  const diffInYear = inputDate.diff(todayDate, 'years');

  if (diffInYear === 0) return moment(inputDate).format('MMM DD');
  return moment(inputDate).format('MMM DD, YYYY');
}

export const meijerSupportNumber = 18773634537;
